import type { ReactNode } from 'react';

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

// Spread on the Formik <Form> so that it fills its container (e.g. a
// RightDrawer) and lets FormLayout scroll its content.
export const FORM_LAYOUT_STYLE = {
  display: 'flex',
  flex: 1,
  overflow: 'auto',
  width: '100%',
} as const;

interface Props {
  readonly actions: ReactNode;
  readonly children: ReactNode;
  readonly error?: ReactNode;
  readonly header?: ReactNode;
  readonly title?: string | null;
}

// Drawer form layout shared with the wizards: only the content scrolls, so the
// actions always stay visible at the bottom of the drawer.
export const FormLayout = ({
  actions,
  children,
  error,
  header,
  title,
}: Readonly<Props>) => (
  <Stack sx={{ width: '100%' }}>
    {!!title && (
      <Box sx={{ pt: 1, pb: 1 }}>
        <Typography sx={{ mt: 2, mb: 2 }} variant="h5">
          {title}
        </Typography>
      </Box>
    )}
    {header}
    <Box sx={{ flexGrow: 1, overflow: 'auto', pt: 1 }}>{children}</Box>
    {!!error && <Box sx={{ mt: 2 }}>{error}</Box>}
    <Box sx={{ mt: 2 }}>{actions}</Box>
  </Stack>
);
